import React, { useEffect, useState } from 'react';
import { Alert, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row, RSelect } from '../../../../../../components/Component';
import TextInput from '../../../../../components/inputs/TextInput';
import { employee_dashboard_actions_helper } from '../../../../../../actions/actions_helper';
import { useDispatch } from 'react-redux';
import { fail_create_customer_account, loading_create_customer_account, reset_create_customer_account, success_create_customer_account } from '../../../../../../reducers/dashboard_reducers/user_accounts/create_customer_account_Slice';
import { CREATE_COMPANY_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG, CREATE_COMPANY_USER_ACCOUNT_LIST_ERR_MSG, CREATE_COMPANY_USER_ACCOUNT_LIST_SUCCESS_MSG, CREATE_CUSTOMER_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG, CREATE_CUSTOMER_USER_ACCOUNT_LIST_ERR_MSG, CREATE_CUSTOMER_USER_ACCOUNT_LIST_SUCCESS_MSG } from '../../../../../../constants/success_error_messages_consts';
import { CREATE_COMPANY_ACCOUNT, CREATE_CUSTOMER_ACCOUNT } from '../../../../../../api/api_data';
import { messageToast } from '../../../../../../utils/Utils';
import { useSelector } from 'react-redux';
import * as app_consts from "../../../../../../constants/react_app_consts";
import PhoneInput from 'react-phone-input-2';
import { EMAIL_REGEX, NUMBERS_ONLY_REGEX, ZAMIBAN_PHONE_NUMBER_REGEX } from '../../../../../../utils/RegexUtils';
import { fail_create_compnay_account, loading_create_compnay_account, reset_create_compnay_account, success_create_compnay_account } from '../../../../../../reducers/dashboard_reducers/user_accounts/create_compnay_account_Slice';

const initialState = {
 company_name: "",
 pacra_registration_number: "",
 tax_number: "",
 company_email_address: "",
 company_mobile_number: "",
 phone_number: "",
};

const AddUserAccountModal = ({ data, successFunction }) => {

 const [errorVal, setError] = useState("");
 const [user_data, setUserData] = useState(data);
 const [addLoading, setAddLoading] = useState(false);
 const dispatch = useDispatch();
 const [selected_account_type, setSelectedAccountType] = useState("");
 const [formData, setFormData] = useState(initialState);

 const account_types = [{ value: "individual_customer_account", label: "Individual Customer Account" }, { value: "company_user_account", label: "Company Customer Account" }];

 useEffect(() => {
  setUserData(data);
  setFormData(initialState);
 }, [data]);

 const handleSubmit = () => {
  setError("");
  setAddLoading(true);
  // Send API Request
  dispatch(
   employee_dashboard_actions_helper(
    loading_create_customer_account,
    success_create_customer_account,
    fail_create_customer_account,
    CREATE_CUSTOMER_USER_ACCOUNT_LIST_ERR_MSG,
    CREATE_CUSTOMER_USER_ACCOUNT_LIST_SUCCESS_MSG,
    app_consts.POST,
    CREATE_CUSTOMER_ACCOUNT,
    { phone_number: user_data.phone_number },
    CREATE_CUSTOMER_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG
   )
  );
 };

 // Listen to Reducers For Creating Customer Account
 const create_customer_account = useSelector((state) => state.create_customer_account.create_customer_account);
 //
 useEffect(() => {
  if (create_customer_account.status !== app_consts.IDLE)
  {
   if (create_customer_account.status === app_consts.LOADING)
   {
    setError("");
    setAddLoading(true);
   } else
   {
    setAddLoading(false);
    if (create_customer_account.status === app_consts.FAIL)
    {
     messageToast(create_customer_account.message, app_consts.FAIL);
     setError(create_customer_account.message, app_consts.FAIL);
    } else if (create_customer_account.status === app_consts.SUCCESS)
    {
     messageToast(CREATE_CUSTOMER_USER_ACCOUNT_LIST_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
    }
    dispatch(reset_create_customer_account());
   }
  }
 }, [create_customer_account]);

 // Handle Input Changes
 const handleChange = (e) => {
  const name = e.target.name;
  const value = e.target.value;
  if (name === "pacra_registration_number")
  {
   setPacra_Number(value);
  } else if (e.target.name === "tax_number")
  {
   setTax_Number(value);
  } else if (e.target.name === "company_email_address")
  {
   setemail_Address(value);
  } else if (e.target.name === "company_mobile_number")
  {
   setPhoneNumber(value);
  }
  setFormData({ ...formData, [name]: value });
 };

 //Checking Valid Phone Number
 const [comp_phone_number, setPhoneNumber] = useState("");
 const [validPNumber, setValidPNumber] = useState(false);
 const [inputPNumberFocus, setInputPNumberFocus] = useState(false);

 //Checking Valid Email Address
 const [email_Address, setemail_Address] = useState("");
 const [validEmail_Address, setValidEmail_Address] = useState(false);
 const [inputEmail_AddressFocus, setInputEmail_AddressFocus] = useState(false);

 //Checking Valid Tax Number
 const [tax_number, setTax_Number] = useState("");
 const [validtTax_Number, setValidTax_Number] = useState(false);
 const [inputtTax_NumberFocus, setInputTax_NumberFocus] = useState(false);

 //Checking Valid Pacra Number
 const [pacra_number, setPacra_Number] = useState("");
 const [validPacra_Number, setValidPacra_Number] = useState(false);
 const [inputPacra_NumberFocus, setInputPacra_NumberFocus] = useState(false);


 // filter country iso from phone NUmber
 const handlePhoneNumberChange = (country, phone) => {
  setFormData({ ...formData, ["iso_code_2"]: phone.countryCode.toUpperCase(), ["company_mobile_number"]: country });
 };

 // Listen to Changes So that they Can be Validated

 //Checking States to see if Pacra Number valid or not
 useEffect(() => {
  const result = NUMBERS_ONLY_REGEX.test(pacra_number);
  if (pacra_number.length !== 12)
  {
   setValidPacra_Number(false);
  } else if (pacra_number.length === 12)
  {
   setValidPacra_Number(result);
  }
 }, [pacra_number]);

 //Checking States to see if Tax Number valid or not
 useEffect(() => {
  const result = NUMBERS_ONLY_REGEX.test(tax_number);
  if (tax_number.length !== 10)
  {
   setValidTax_Number(false);
  } else if (tax_number.length === 10)
  {
   setValidTax_Number(result);
  }
 }, [tax_number]);

 //Checking States to see if Email Address valid or not
 useEffect(() => {
  const result = EMAIL_REGEX.test(email_Address);
  setValidEmail_Address(result);
 }, [email_Address]);

 //Checking States to see if Phone Number is valid or not
 useEffect(() => {
  const result = ZAMIBAN_PHONE_NUMBER_REGEX.test(comp_phone_number);
  setValidPNumber(result);
 }, [comp_phone_number]);

 const handleCompanySumbit = () => {
  setError("");
  setAddLoading(true);
  dispatch(
   employee_dashboard_actions_helper(
    loading_create_compnay_account,
    success_create_compnay_account,
    fail_create_compnay_account,
    CREATE_COMPANY_USER_ACCOUNT_LIST_ERR_MSG,
    CREATE_COMPANY_USER_ACCOUNT_LIST_SUCCESS_MSG,
    app_consts.POST,
    CREATE_COMPANY_ACCOUNT,
    { ...formData, phone_number: user_data.phone_number },
    CREATE_COMPANY_USER_ACCOUNT_LIST_ACCESS_DENIED_MSG
   )
  );
 };

 // Listen to Reducers For Creating Customer Account
 const create_compnay_account = useSelector((state) => state.create_compnay_account.create_compnay_account);
 //
 useEffect(() => {
  if (create_compnay_account.status !== app_consts.IDLE)
  {
   if (create_compnay_account.status === app_consts.LOADING)
   {
    setError("");
    setAddLoading(true);
   } else
   {
    setAddLoading(false);
    if (create_compnay_account.status === app_consts.FAIL)
    {
     messageToast(create_compnay_account.message, app_consts.FAIL);
     setError(create_compnay_account.message, app_consts.FAIL);
    } else if (create_compnay_account.status === app_consts.SUCCESS)
    {
     messageToast(CREATE_COMPANY_USER_ACCOUNT_LIST_SUCCESS_MSG, app_consts.SUCCESS);
     successFunction();
    }
    dispatch(reset_create_compnay_account());
   }
  }
 }, [create_compnay_account]);

 return (
  <>
   {errorVal && (
    <div className="mb-3 w-100">
     <Alert color="danger" className="alert-icon">
      <Icon name="alert-circle" /> {errorVal}{" "}
     </Alert>
    </div>
   )}
   <form
    onSubmit={(e) => {
     e.preventDefault();
    }}
   >
    <Row className="g-4">
     <TextInput
      label="User Name"
      disabled
      required
      type="text"
      id_val="username"
      value={user_data?.middle_name ? `${user_data?.first_name} ${user_data?.middle_name} ${user_data?.surname}` : `${user_data?.first_name} ${user_data?.surname}`}
      colSize="12"
      name="username"
     />
     <Col>
      <div className="form-group">
       <label className="form-label mb-1 text-md" htmlFor="username">
        Account Type<span className='text-danger pr-2'>{` *`}</span>
       </label>
       <div className="form-control-wrap align-items-center w-100 d-flex flex-row mb-2 justify-between">
        <div className="w-100">
         <RSelect
          options={account_types}
          className="w-100"
          placeholder="Search"
          id="account_type"
          onChange={(e) => {
           setSelectedAccountType(e.value);
           //   setPreviewData({ ...previewData, ["product_type_name"]: e.label });
          }}
         />
        </div>
       </div>
      </div>
     </Col>
     {
      selected_account_type === "company_user_account" ?
       <>

        <TextInput
         label="Company Name"
         type="text"
         id_val="company_name"
         value={formData.company_name}
         handleChange={handleChange}
         name="company_name"
         maxlength="100"
         required
        />
        <TextInput
         label="Tax Number"
         type="text"
         id_val="tax_number"
         value={formData.tax_number}
         handleChange={handleChange}
         name="tax_number"
         required
         maxlength="10"
         error_stat={inputtTax_NumberFocus && tax_number && !validtTax_Number ? true : false}
         err_Msg={"Tax Number Should consist of 10 Numerical Characters."}
         onFocus={() => setInputTax_NumberFocus(true)}
        />
        <Col lg="6">
         <div className="form-group">
          <div className="form-label-group">
           <label className="form-label" htmlFor="company_mobile_number">
            Company Mobile Number<span className='text-danger pr-2'>{` *`}</span>
           </label>
          </div>
          <div className="form-control-wrap">
           <PhoneInput
            country={"zm"}
            value={formData.company_mobile_number}
            onChange={(country, phone) => handlePhoneNumberChange(country, phone)}
            copyNumbersOnly={false}
            inputStyle={{ width: '100%' }}
           />
          </div>
         </div>
        </Col>
        <span className="fs-18px text-base fw-bold">Optional</span>
        <TextInput
         label="Company Email Address"
         type="text"
         id_val="company_email_address"
         value={formData.company_email_address}
         handleChange={handleChange}
         name="company_email_address"
         maxlength="160"
         error_stat={inputEmail_AddressFocus && email_Address && !validEmail_Address ? true : false}
         err_Msg={"Please Insert a Valid Email Address."}
         onFocus={() => setInputEmail_AddressFocus(true)}
        />
        <TextInput
         label="Pacra Registration Number"
         type="text"
         id_val="pacra_registration_number"
         value={formData.pacra_registration_number}
         handleChange={handleChange}
         name="pacra_registration_number"
         maxlength="12"
         error_stat={inputPacra_NumberFocus && pacra_number && !validPacra_Number ? true : false}
         err_Msg="Pacra Registration Number Should consist of 12 Numerical Characters."
         onFocus={() => setInputPacra_NumberFocus(true)}
        />
        <Col xl="12" className="d-flex justify-content-end">
         <Button
          onClick={handleCompanySumbit}
          size="lg"
          type="submit"
          color="primary"
          disabled={
           addLoading
            ? addLoading
            : !(
             formData.company_mobile_number &&
             validtTax_Number &&
             formData.company_name
            )
          }
         >
          {addLoading ? <Spinner size="sm" color="light" /> : "Add Company Account"}
         </Button>
        </Col>
       </>
       :
       <>
        <Col xl="12" className="d-flex justify-content-end mt-4 mr-2">
         <Button onClick={handleSubmit} disabled={addLoading || selected_account_type !== "individual_customer_account"} color="primary">
          {addLoading ? <Spinner size="sm" color="light" /> : "Add User Account"}
         </Button>
        </Col>
       </>
     }
    </Row>
   </form>
  </>
 );
};

export default AddUserAccountModal;